/**
 * @flow
 * @format
 */

const baseConfig = {
  verbose: process.env.NODE_ENV !== 'production',
  accessToken: process.env.REACT_APP_ROLLBAR_API_TOKEN,
  captureUncaught: process.env.NODE_ENV === 'production',
  handleUncaughtExceptions: process.env.NODE_ENV === 'production',
  handleUnhandledRejections: process.env.NODE_ENV === 'production',
  autoInstrument: true,
  payload: {
    environment: process.env.NODE_ENV,
  },
};

const Rollbar = require('rollbar');

// const Rollbar = new rollbar(baseConfig); // eslint-disable-line new-cap

type ClientConfigType = {
  code_version?: string,
  guess_uncaught_frames?: boolean,
  source_map_enabled?: boolean,
};

const baseClientConfig = {
  source_map_enabled: true,
  code_version: process.env.REACT_APP_COMMIT_SHA,
  guess_uncaught_frames: true,
};

class RollbarWrapper {
  rollBar = null;
  static instance: any;

  error: (message: string, payload?: { [string]: any }) => void;
  critical: (message: string, payload?: { [string]: any }) => void;
  warning: (message: string, payload?: { [string]: any }) => void;
  debug: (message: string, payload?: { [string]: any }) => void;
  configure: (payload: any) => void;

  constructor(clientConfig: ClientConfigType = {}) {
    if (!RollbarWrapper.instance) {
      RollbarWrapper.instance = this;

      const config = {
        payload: {
          client: {
            javascript: {
              ...baseClientConfig,
              ...clientConfig,
            },
          },
        },
      };

      const rollBar = new Rollbar(clientConfig); // eslint-disable-line new-cap

      // https://rollbar.com/docs/source-maps/
      rollBar.configure(config);
      this.rollBar = rollBar;
    }
    return this.rollBar;
  }

  // https://github.com/netguru/redux-rollbar-middleware#state-sanitization
  static stateSanitizer(state: any) {
    return Object.assign({}, state);
  }
}

// export const middleware = rollbarMiddleware(stateSanitizer);
const instance = new RollbarWrapper(baseConfig);
// Object.freeze(instance);

export default instance;



// WEBPACK FOOTER //
// ./src/utils/rollbar.js